interface WorkedExampleProps {
  text: string;
}

/**
 * Inline worked-example callout, mirroring the page's Formula component but with
 * an accent "Example" label. Renders a concrete calculation from the running
 * example company.
 */
const WorkedExample = ({ text }: WorkedExampleProps) => (
  <div className="mt-3 rounded-xl bg-accent/5 border border-accent/20 px-5 py-4">
    <span className="block text-[0.65rem] uppercase tracking-[0.16em] text-accent mb-1.5">
      Example
    </span>
    <p className="text-[15px] md:text-base leading-relaxed text-foreground">{text}</p>
  </div>
);

export default WorkedExample;
